module.exports = "<div class=\"container\r\n\">\r\n<h2>Scientific committee</h2>\r\n<ul>\r\n  <li><a>John Coates</a> University of Cambridge</li>\r\n  <li><a>Wiesława Nizioł</a> CNRS, ÉNS-Lyon</li>\r\n  <li><a>Cristian Popescu</a> University of California, San Diego</li>\r\n  <li><a>Peter Schneider</a> Universität Münster</li>\r\n  <li><a>Jacques Tilouine</a> Université Paris 13</li>\r\n</ul>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/rzonsol/WebstormProjects/banaszak60/src/app/main/scientific-comittee/scientific-comittee.component.html
// module id = ../../../../../src/app/main/scientific-comittee/scientific-comittee.component.html
// module chunks = main